import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';
import SvgDragHandleBars24 from '../../../icons/interface/DragHandleBars24.js';
import { useDrop } from '../../../node_modules/react-dnd/dist/hooks/useDrop/useDrop.js';
import { useDrag } from '../../../node_modules/react-dnd/dist/hooks/useDrag/useDrag.js';

var ReactTableDraggableRow = function (_a) {
    var row = _a.row, onDragRow = _a.onDragRow, disabled = _a.disabled;
    var _b = useDrop({
        accept: 'row',
        drop: function (draggedRow) { return onDragRow(draggedRow.index, row.index); }
    }), dropRef = _b[1];
    var _c = useDrag({
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging()
        }); },
        item: row,
        type: 'row'
    }), isDragging = _c[0].isDragging, dragRef = _c[1], previewRef = _c[2];
    return (jsx("tr", __assign({ ref: previewRef, style: { opacity: isDragging ? 0.5 : 1 } }, { children: row.getVisibleCells().map(function (cell, i) {
            return i === 0 ? (jsx("td", __assign({ ref: dropRef }, { children: jsx("div", __assign({ className: "position-relative" }, { children: jsx("div", __assign({ className: "position-absolute start-50 translate-middle-x", style: { top: '-2px' } }, { children: jsx("button", __assign({ ref: dragRef, className: classNames('bg-transparent border-0 text-default', disabled && 'pe-none opacity-20') }, { children: jsx("span", __assign({ "aria-hidden": "true" }, { children: jsx(SvgDragHandleBars24, {}) })) })) })) })) }), cell.id)) : (jsx("td", { children: flexRender(cell.column.columnDef.cell, cell.getContext()) }, cell.id));
        }) })));
};

export { ReactTableDraggableRow };
